export const LOADING_OVERLAY_SX = {
  alignItems: 'center',
  bgcolor: 'rgba(255, 255, 255, 0.65)',
  display: 'flex',
  inset: 0,
  justifyContent: 'center',
  position: 'absolute',
  zIndex: 1,
} as const;
